import { render, staticRenderFns } from "./InputInboxApproval.vue?vue&type=template&id=420a0a60&"
import script from "./InputInboxApproval.vue?vue&type=script&lang=js&"
export * from "./InputInboxApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports